import datesMixin from "../../mixins/datesMixin";
let date = new Date();

export const namespaced = true;

export const mutations = {
    // root mutations to clear state from applicable modules
    CLEAR_STATE(state){
        this.state.app.token = "";
        this.state.bookTravel = {
            result: {
                trip: {},
                atc: {}, 
                flight: {},
                car: {},
                hotel: {}
            },
            recentSearches: [],
            formsCollapsed: {
                flight: false,
                car: false,
                hotel: false,
            },
            areResultsOld: {
                flight: false,
                car: false,
                hotel: false,
            },
            showMapView: {
                flight: false,
                car: false,
                hotel: false,
            },
            lastHotelSearch: {},
            flightDetails: {
                show: false,
                journeys: {}
            },
            fareOptions: {
                show: false,
                jsolution: {}
            },
            expectedUnbundledJourneysCount: 0,
            selectedUnbundledJourneys: [],
            //searchByScheduleFlights: []
            searchLoadingStatus: false,
            flightSearchComplete: false,
            anchoredSearchTimer: {},
            numGuests: 0,
            guests: []
        }
        this.state.co2Info = {
            flightsWithCO2Info: [],
        };
        this.state.flightsInfo = {
            flightsInfo: [],
        };
        this.state.meetings = {
            meetingInfo: null,
            meetingProfileSet: false,
            meetingSurveySet: false,
            meetingAirportSelected: null,
        };
        this.state.pnr = {
            //pending: {},
            queue: [],
            status: []
        }
        this.state.travellersAndTrips = {
            pendingTrips: [],
            currentTravellerProfile: {},
            profile: {},
            otherProfiles: {},
            travellers : {
                tripType: 'business',
                bookFor: 'user',
                others: [],
                set: true
            },
            unaccompaniedMinorAirlineDetails: [],
        }
    },
    CLEAR_DETAILS(state){

        this.state.bookTravel.formsCollapsed.flight = false,
        this.state.bookTravel.formsCollapsed.car = false,
        this.state.bookTravel.formsCollapsed.hotel = false,

        this.state.bookTravel.areResultsOld.flight = false,
        this.state.bookTravel.areResultsOld.car = false,
        this.state.bookTravel.areResultsOld.hotel = false,

        this.state.bookTravel.showMapView.flight = false,
        this.state.bookTravel.showMapView.car = false,
        this.state.bookTravel.showMapView.hotel = false,

        this.state.bookTravel.expectedUnbundledJourneysCount = 0,
        this.state.bookTravel.selectedUnbundledJourneys = [],

        this.state.bookTravel.atc = {},

        this.state.searchByScheduleFlights = []
    },
}

export const actions = {
    // root action to clear state from applicable modules
    clearState(context){
        context.commit('CLEAR_STATE');
        context.commit('hotelSearch/CLEAR_STATE', null, { root: true });       
    },
}